import { useTexture, meshBounds } from '@react-three/drei'
import { useThree, useLoader } from '@react-three/fiber'
import { AudioLoader, AudioListener, Audio } from 'three'

export default function PhotoOnWall()
{
    const texture = useTexture('./textures/eastereggs/saw.jpg')

    /**
     * Sounds
     */

    const { camera } = useThree()
    const trapSound = useLoader(AudioLoader, './sounds/dbd-bear-trap-being-disarmed-135902.mp3')
    
    const playSound = () =>
    {
        const listener = new AudioListener()
        camera.add(listener)
        const sound = new Audio(listener)
        sound.setBuffer(trapSound)
        sound.setVolume(1)
        sound.play()
        sound.onEnded = () => {camera.remove(listener)}
    }

    return <>

        <mesh  
            position={[ -1.99, -0.4, 0.5 ]}  
            rotation-y={Math.PI/2}
            rotation-z={ -0.1 }
            raycast={meshBounds}
            onClick={playSound}
            onPointerEnter={ () => { document.body.style.cursor = 'pointer' } }
            onPointerLeave={ () => { document.body.style.cursor = 'default' } }
        >
            <planeGeometry   
                args={[261 * 0.0009 , 319 * 0.0009]} 
            />
            <meshStandardMaterial 
                map={texture} 
            />
        </mesh>
        
    </>   
}